import Vue from "vue";
import { Component, Prop, Emit } from "vue-property-decorator";
import ValidationMessage from "./validation-message.vue";
import { ValidationErrors } from "../../new-contract-vue";

@Component({
    components: { ValidationMessage }
})

export default class ValidatedFormGroup extends Vue {
    @Prop()
    public validationErrors: ValidationErrors;
    @Prop()
    public validationId: string;

    constructor() {
        super();

        if (this.validationErrors == null)
            console.error("Property validationErrors not set!");
    }
}